/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_TitleInputs */

const en_setup_title = /** @type {(inputs: Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome! Who's cooking?`)
};

const de_setup_title = /** @type {(inputs: Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen! Wer kocht bei euch?`)
};

/**
* | output |
* | --- |
* | "Welcome! Who's cooking?" |
*
* @param {Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_title = /** @type {((inputs?: Setup_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_title(inputs)
	return en_setup_title(inputs)
});